export default __webpack_public_path__ + "static/media/cif-al.fbb41328.svg";